export default {
  data() {
    return {
      iframeUrl: `${process.env.VUE_APP_BASE_AUTH_MODULE || 'http://localhost:5173'}/forgot-password`,
    }
  },
  mounted() {
    window.addEventListener('message', this.handleMessage)
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleMessage)
  },
  methods: {
    handleMessage(event) {
      // Placeholder for communicating with partner-v2 iframe
      // Example: If partner-v2 wants to redirect to login on the host level
      if (event.data && event.data.type === 'REDIRECT_LOGIN') {
        this.$router.push({ name: 'auth-login' })
      }
    }
  }
}
